import { render, staticRenderFns } from "./OrgDeptList.vue?vue&type=template&id=cd46ef52&scoped=true"
import script from "./OrgDeptList.vue?vue&type=script&lang=js"
export * from "./OrgDeptList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd46ef52",
  null
  
)

export default component.exports